import React from 'react';
import View from 'components/View';
import CoachingHelpHeader from 'coaching/components/CoachingHelpFormView/CoachingHelpHeader';
import CoachingHelpHomeIntro from 'coaching/components/CoachingHelpFormView/CoachingHelpHomeIntro';
import CoachingHelpContactUsSection from 'coaching/components/CoachingHelpFormView/CoachingHelpContactUsSection';
import CoachingHelpArticlesSection from 'coaching/components/CoachingHelpFormView/CoachingHelpArticlesSection';
import CoachingHelpChatSection from 'coaching/components/CoachingHelpFormView/CoachingHelpChatSection';
import { GetCoachingHelpForm_me } from 'coaching/queries/__generated__/GetCoachingHelpForm';

import 'coaching/components/styles/CoachingHelpHomeView.scss';

type Props = {
  me: GetCoachingHelpForm_me | null | undefined;
};

export default function CoachingHelpHomeView(props: Props) {
  const isAuthenticated = !!props.me;
  const firstName = props.me?.first_name ?? undefined;
  const lastName = props.me?.last_name ?? undefined;

  return (
    <React.Fragment>
      <CoachingHelpHeader
        showLoginButton={!isAuthenticated}
        firstName={firstName}
        lastName={lastName}
      />
      <View className="CoachingHelpHomeView CoachingHelpHomeView--darker">
        <CoachingHelpHomeIntro isAuthenticated={isAuthenticated} firstName={firstName} />
      </View>
      <View className="CoachingHelpHomeView CoachingHelpHomeView--lighter">
        <CoachingHelpContactUsSection />
      </View>
      <View className="CoachingHelpHomeView CoachingHelpHomeView--darker">
        <CoachingHelpArticlesSection />
      </View>
      <View className="CoachingHelpHomeView CoachingHelpHomeView--lighter">
        <CoachingHelpChatSection />
      </View>
    </React.Fragment>
  );
}
